<ng-template #tpl>

	<ng-container *transloco="let translate">
  
	  <div class="talign-c">
  
		<div class="w-100 m-1-tb">
		  <img
			src="assets/images/core/robot-error.svg"
			style="height: 120px;"
			>
		  <div class="fs-xs fc-warn m-1-t">
			@if (!!$quotaNodes()) {
			  <span>
				{{ $quotaNodes()?.used || 0 }}/{{ $quotaNodes()?.total || 0 }}
			  </span>
			}
  
			@if (!$quotaNodes()) {
			  <span>
				&nbsp;
			  </span>
			}
		  </div>
		</div>
  
		<p class="fw-bold fs-icon talign-c">
		  {{ translate('errorModals.chat_ai_quota.title') }}
		</p>
  
		<p class="m-3-tb" [innerHTML]="translate('errorModals.chat_ai_quota.description')">
		</p>
  
		<button
		  class="w-100 p-1q-tb p-3-rl border-box bg-primary fw-bold fc-white"
		  style="border-radius: var(--spacing);"
		  (click)="confirm()"
		  >
		  {{ translate('errorModals.quota_common.check') }}
		</button>
  
		<button
		  class="w-100 p-1q-tb p-3-rl border-box fw-bold fc-400"
		  (click)="cancel()"
		  >
		  {{ translate('general.close') }}
		</button>
  
	  </div>
  
	</ng-container>
  
  </ng-template>
  